import './index.scss';
import classNames from 'classnames';
import React from 'react';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useRecentActivity } from '../../providers';
import ActivityGrid from '../activity_grid';
const DocumentTab = () => {
    const { hasPermission } = useUser();
    const { documents } = useRecentActivity();
    const hasMultipleTabs = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS) &&
        hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS);
    const containerClasses = classNames('empty-document-activity-container', {
        'with-tabs': hasMultipleTabs,
    });
    if ((documents === null || documents === void 0 ? void 0 : documents.length) === 0) {
        return (React.createElement("div", { className: containerClasses },
            React.createElement("span", { className: 'empty-document-svg' }),
            React.createElement("div", { className: 'empty-heading' }, "No recently viewed documents"),
            React.createElement("div", { className: 'empty-sub-heading' }, "A history of documents you view will display here")));
    }
    return React.createElement(ActivityGrid, { recentDocumentActivities: documents, recentComparisonActivities: null });
};
export default DocumentTab;
